import * as React from 'react';
import { IComment, ICommentView } from '../../common/sharedTypes';
import { connect } from 'react-redux';
import { UserInfo } from '../Login/common/defaults';
import Form from 'react-bootstrap/Form';
import {
  Row,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
import './assets/commentPopover.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { saveNewComment, saveCommentView } from './redux-objects/actions';
import * as urls from '../shared/urls';
import PopoverContent from 'react-bootstrap/PopoverContent';
import PopoverTitle from 'react-bootstrap/PopoverTitle';

import DataTable from '../DataTable';
import moment from 'moment';
import ReactDOM from 'react-dom';
import CommentsButton from './CommentsButton';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface ICommentsViewProps {
  currentUser: UserInfo;
  reportId: number;
  crashKey?: string;
  reportComments: IComment[];
  saveNewComment?: (url: string, comment: IComment) => Promise<IComment>;
  saveCommentView?: (
    url: string,
    commentView: ICommentView
  ) => Promise<ICommentView>;
}

export interface ICommentsViewState {
  showViewsId?: number;
  newCommentText: string;
}
const initialState: ICommentsViewState = {
  showViewsId: null,
  newCommentText: '',
};

class CommentsView extends React.Component<
  ICommentsViewProps,
  ICommentsViewState
> {
  public constructor(props: ICommentsViewProps) {
    super(props);
    this.state = initialState;
  }

  // handleShowViews(event: React.MouseEvent<HTMLElement>, rowData: any) {
  //   this.setState({ showViewsId: rowData.reportId });
  //   console.log(event, rowData);
  // }
  componentDidMount = () => {
    if (this.props.reportComments && this.props.reportComments.length > 0) {
      this.saveCommentView();
    } else {
      console.log('cdm before reports');
    }
  };

  saveComment = () => {
    if (this.state.newCommentText.trim() == '') {
      return;
    }

    const newComment: IComment = {
      id: 0,
      reportId: this.props.reportId,
      text: this.state.newCommentText,
    };
    this.props
      .saveNewComment(urls.SAVE_REPORT_COMMENT, newComment)
      .then((newComment) => {
        this.setState({ newCommentText: '' });
      });
  };

  saveCommentView = () => {
    this.props.reportComments.forEach((c) => {
      if (
        c.createdById == this.props.currentUser?.id ||
        c.commentViews.some((x) => x.viewedById == this.props.currentUser?.id)
      ) {
        return;
      }
      const newCommentView: ICommentView = {
        id: 0,
        commentId: c.id,
        viewedById: this.props.currentUser?.id,
      };
      this.props.saveCommentView(urls.ADD_COMMENT_VIEW, newCommentView);
    });
  };

  onCloseViewModal = () => {
    this.setState({ showViewsId: null });
  };

  onCommentChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'comment':
        this.setState({
          newCommentText: el.value,
        });
        break;
      default:
        break;
    }
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        createdCell: (td, cellData, rowData: IComment, row, col) =>
          ReactDOM.render(
            <span>
              {rowData.createdBy != null ? rowData.createdBy.username : ''}
              <br /> {moment(rowData.createdDate).format('lll')}
            </span>,
            td
          ),
      },
      {
        targets: 1,
        width: '100%',
      },
      {
        targets: 2,
        width: '40px',
        createdCell: (td, cellData, rowData: IComment, row, col) =>
          ReactDOM.render(
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              key={rowData.id}
              placement='left'
              overlay={
                <Popover
                  id={`popover-positioned-left${rowData.id}`}
                  className='popViews'
                >
                  <PopoverTitle as='h3'>Views</PopoverTitle>
                  <PopoverContent>
                    {(rowData.commentViews &&
                      rowData.commentViews.length > 0 &&
                      rowData.commentViews.map((view: ICommentView) => {
                        return (
                          <div key={view.id}>
                            <span>{view.viewedBy.username}</span>
                            <br />
                            <span>{moment(view.viewedDate).format('lll')}</span>
                            <hr />
                          </div>
                        );
                      })) ||
                      'No Views'}
                  </PopoverContent>
                </Popover>
              }
            >
              <i
                className='fas fa-eye fa-lg'
              //onClick={(e) => this.handleShowViews(cellData, rowData)}
              ></i>
            </OverlayTrigger>,
            td
          ),
      },
      {
        targets: 3,
        visible: false,
      },
    ];

    const columns = [
      {
        title: 'Created',
        data: 'reportId',
      },
      {
        title: 'Comment',
        data: 'text',
        className: "tableForceWrap"
      },
      {
        title: '',
        data: 'reportId',
      },
      {
        title: 'hidden date field',
        data: 'createdDate',
      },
    ];
    
    const options = {
      className: 'table table-striped table-bordered',
      select: false,
      dom: 'rtip',
      orderFixed: {
        pre: [3, 'desc'],
      },
    };

    return (
      <div>
        {this.props.reportComments && this.props.reportComments.length > 0 && (
          <React.Fragment>
            <DataTable
              id={`tblComments${this.props.reportId}`}
              key={`tblComments${this.props.reportId}`}
              data={this.props.reportComments.filter(
                (x) => x.reportId == this.props.reportId
              )}
              columns={columns}
              columnDefs={columnDefs}
              actionsColumn='first'
              pageLength={5}
              {...options}
            />
          </React.Fragment>
        )}

        <Form>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col xs='10'>
              <Form.Group controlId='newComment'>
                <Form.Control
                  as='textarea'
                  rows={3}
                  data-field='comment'
                  placeholder='Enter new comment'
                  onChange={this.onCommentChange}
                  value={this.state.newCommentText}
                />
              </Form.Group>
            </Col>
            <Col>
              <Button
                variant='success'
                onClick={this.saveComment}
                disabled={this.state.newCommentText.trim() == ''}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    reportComments: state.Comments.reportComments,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  saveNewComment,
  saveCommentView,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsView);
